const $ = require('jquery');

$(document).ready(function () {
    socialShare();
});

function socialWindow(url) {
    let left = (screen.width - 570) / 2;
    let top = (screen.height - 570) / 2;
    let params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
    window.open(url, "NewWindow", params);
}

function socialShare() {
    let fbShare = $('.share-facebook');
    let twShare = $('.share-twitter');
    let ptShare = $('.share-pinterest');
    let pageUrl = $('meta[property="og:url"]').attr('content');
    let title = $('meta[property="og:title"]').attr('content');
    let description = $('meta[property="og:description"]').attr('content');
    let img = $('meta[property="og:image"]').attr('content');

    fbShare.on('click', function (e) {
        e.preventDefault();
        let targetUrl = $(this).attr('data-url') ? $(this).attr('data-url') : pageUrl;
        socialWindow("https://www.facebook.com/sharer.php?u=" + targetUrl);
    });

    twShare.on('click', function (e) {
        e.preventDefault();
        let targetUrl = $(this).attr('data-url') ? $(this).attr('data-url') : pageUrl;
        let targetText = $(this).attr('data-text') ? $(this).attr('data-text') : title;
        socialWindow("https://twitter.com/intent/tweet?url=" + targetUrl + "&text=" + targetText);
    });

    ptShare.on('click', function (e) {
        e.preventDefault();
        let targetUrl = $(this).attr('data-url') ? $(this).attr('data-url') : pageUrl;
        let targetText = $(this).attr('data-text') ? $(this).attr('data-text') : description;
        let targetImg = $(this).attr('data-img') ? $(this).attr('data-img') : img;
        socialWindow("https://pinterest.com/pin/create/bookmarklet/?media=" + targetImg + "&url=" + targetUrl + "&is_video=false&description=" + targetText)
    })
}
